<template>
  <dl class="list list--definition list--clean">
    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.NAME') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ data.name }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.PACKAGE_NAME') }}</dt>
    <dd class="text-start" dir="rtl">
      {{ data.packageName }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.BUDGET') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ priceFormat(data.remainingBudget) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.BASIC.TARGETED_CPI') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ priceFormat(data.targetedCpi) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.START_DATE') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ translateDate(data.startDate) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.END_DATE') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ translateDate(data.endDate) }}
    </dd>

    <dt>{{ $t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY.STATUS') }}</dt>
    <dd class="text-start" dir="ltr">
      {{ $t(statusText) }}{{ statusPostfix }}

      <ElPopover
        placement="top"
        trigger="hover"
        width="400"
        :title="$t('ADVERTISEMENT.CAMPAIGNS.STATUS')"
      >
        <span
          v-dompurify-html="
            $t('ADVERTISEMENT.CAMPAIGNS.STATUS_DISCOVERY_DESCRIPTION')
          "
        />
        <template #reference>
          <span class="el-icon-info campaign-info-list__info" />
        </template>
      </ElPopover>
    </dd>

    <dt>
      {{ $t('ADVERTISEMENT.CAMPAIGNS.TRACKER_STATUS') }}
      <ElPopover placement="top" trigger="hover" width="400">
        <span
          v-dompurify-html="$t('ADVERTISEMENT.CAMPAIGNS.BASIC.TRACKER_HELP')"
        />
        <template #reference>
          <span class="el-icon-info campaign-info-list__info" />
        </template>
      </ElPopover>
    </dt>
    <dd class="text-start" dir="rtl">
      <a
        v-if="data.clickTrackerLink"
        :href="data.clickTrackerLink"
        target="_blank"
      >
        {{ data.clickTrackerLink }}
      </a>
      <p v-else>{{ $t(trackerStatus) }}</p>
    </dd>
  </dl>
</template>

<script>
import { dateFormat } from '@/utils/date';
import lang from '@/mixins/lang';
import { format as priceFormat } from '@/utils/number';
import translateCampaignStatus from '../../common/utility/translators/translateCampaignStatus';
import percentage from '@/utils/percentage';

export default {
  name: 'CampaignInfoList',
  mixins: [lang],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusPostfix() {
      if (this.data.status === 'not_started' && this.data.isPaused) {
        return ` (${this.$t('ADVERTISEMENT.CAMPAIGNS.STOPPED')})`;
      }
      return '';
    },
    statusText() {
      return translateCampaignStatus(this.data.status?.toLowerCase());
    },
    trackerStatus() {
      return this.data.hasTracker
        ? 'ADVERTISEMENT.CAMPAIGNS.HAS_TRACKER'
        : 'ADVERTISEMENT.CAMPAIGNS.BASIC.DOESNT_HAVE_TRACKER';
    },
    consumedBudgetPercentage() {
      return percentage(this.data.spentBudget, this.data.budget);
    },
  },
  methods: {
    priceFormat,

    translateDate(date) {
      if (!date) return '';

      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      try {
        return dateFormat()(toFormat)(date);
      } catch (error) {
        return date;
      }
    },
  },
};
</script>

<style lang="scss">
.campaign-info-list {
  &__info {
    color: #c0c4cc;
  }
}
</style>
